import React, { useRef, useState } from 'react';
import { Col, Input, Label, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import ButtonIcon from '../UI/buttons/ButtonIcon';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ options, selectType, dateFilter, keyField }) => {

    const today = new Date().getFullYear() + '-' + (new Date().getMonth() + 1 < 10 ? ('0' + new Date().getMonth() + 1) : new Date().getMonth()) + 1 + '-' + new Date().getDate();
    const [date, setDate] = useState(false);
    const [minDate, setMinDate] = useState(false);
    const [maxDate, setMaxDate] = useState(false);
    const start_date_ref = useRef();
    const end_date_ref = useRef();

    return   <>
                <Col>
                    <Row className={date ? 'mb-3' : ''}>
                        {options&&<Col className='d-flex align-items-center'>
                            <Label className='mr-2 mb-0'>Filtrar</Label>
                            <select className='form-control' defaultValue='Contratado' onChange={(e) => {
                                selectType((prev) => ({ ...prev, [keyField]: e.target.value }));
                            }}>
                                {options.map(((val, i) => <option key={i} value={val.value} disabled={val.disabled}>{val.displayName}</option>))}
                            </select>
                        </Col>}
                        {dateFilter&&
                        <Col className={`d-flex align-items-center pr-4 pl-4`} xs='auto'>
                            <Label style={{ cursor:'pointer' }} for={'check'} className='mb-0'>¿Filtrar por fecha?</Label>
                            <Input style={{ cursor:'pointer' }} id={'check'} className='mt-0' type='checkbox' onChange={(e) =>{
                                if(!e.target.checked) {
                                    selectType((prev) => ({ ...prev, start_date:null, end_date:null }))
                                    setMinDate(false);
                                    setMaxDate(false);
                                    };
                                    setDate(e.target.checked);
                                }} />
                            </Col>}
                    </Row>
                    {date&&
                    <Row className='justify-content-center justify-content-md-between align-items-center'>
                        <Col md={4} sm={12} className='my-2 my-md-0'>
                            <input onChange={e => setMinDate(e.target.value)} ref={start_date_ref} type={'date'} max={maxDate || today} className='form-control' />
                        </Col>
                        <b className=' text-center text-md-right'>a</b>
                        <Col md={4} sm={12} className='my-2 my-md-0'>
                            <input onChange={e => setMaxDate(e.target.value)} ref={end_date_ref} disabled={!minDate} type={'date'} max={today} min={minDate && minDate} className='form-control' />
                        </Col>
                        <Col md={3} sm={12} className='my-2 my-md-0 text-center text-md-right'>
                            <ButtonIcon onClick={e => selectType((prev) => ({ ...prev, start_date: start_date_ref.current.value, end_date: end_date_ref.current.value }))} className='text-nowrap' disabled={false} icon={faSearch} color='falcon-default'>Buscar</ButtonIcon>
                        </Col>
                    </Row>}
                </Col>
            </>
}

Filter.propTypes = {
    options: PropTypes.array.isRequired,
    date: PropTypes.bool,
    dateFilter: PropTypes.bool.isRequired
}

export default Filter;